import { deleteCookie, getCookieValue, setCookie } from './cookies';

type ToastType = 'success' | 'error';

interface ToastData {
  type: ToastType;
  message: string;
}

const PERSISTED_TOAST_COOKIE_NAME = 'persisted_toast';

export function setPersistedToast(type: ToastType, message: string) {
  const toastData: ToastData = { type, message };
  setCookie(PERSISTED_TOAST_COOKIE_NAME, JSON.stringify(toastData), {
    sameSite: 'strict',
  });
}

export function getPersistedToast(): ToastData | null {
  const cookieValue = getCookieValue(PERSISTED_TOAST_COOKIE_NAME);
  if (!cookieValue) return null;

  return JSON.parse(cookieValue) as ToastData;
}

export function clearPersistedToast() {
  deleteCookie(PERSISTED_TOAST_COOKIE_NAME);
}
